import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { LoadingService } from './loading.service';
import { RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { AsyncPipe, NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    standalone: true,
    selector: 'loading-indicator',
    templateUrl: './loading-indicator.component.html',
    imports: [
        AsyncPipe,
        NgIf,
        TranslateModule
    ],
    styleUrls: ['./loading-indicator.component.scss']
})
export class LoadingIndicatorComponent implements OnInit, OnDestroy {

    loading$: Observable<boolean>;
    saving$: Observable<boolean>;
    blockPage$: Observable<boolean>;


    @Input() detectRouteTransitions = false;
    private subscription: Subscription;

    constructor(
    private loadingService: LoadingService,
    private router: Router) {
        this.loading$ = this.loadingService.loading$;
        this.saving$ = this.loadingService.saving$;
        this.blockPage$ = this.loadingService.blockPage$;

    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    ngOnInit() {
        if (this.detectRouteTransitions) {
            this.subscription = this.router.events
                .pipe(
                    tap((event) => {
                        if (event instanceof RouteConfigLoadStart) {
                            this.loadingService.loadingOn();
                        } else if (event instanceof RouteConfigLoadEnd) {
                            this.loadingService.loadingOff();
                        }
                    })
                )
                .subscribe();
        }
    }
}
